/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/

import "./MapLayersWidget.scss";
import * as React from "react";
import { useActiveViewport } from "@itwin/appui-react";
import { Flex } from "@itwin/itwinui-react";
import { MapLayersUI } from "../../mapLayers";
import { MapLayerManager } from "./MapLayerManager";

import type { MapLayerOptions } from "../Interfaces";
import { useIsGeoLocated } from "../hooks/useIsGeoLocated";
/**
 * Widget to Manage Map Layers
 * @beta
 */
interface MapLayersWidgetProps {
  mapLayerOptions?: MapLayerOptions;
}
export function MapLayersWidget(props: MapLayersWidgetProps) {
  const [notGeoLocatedMsg] = React.useState(MapLayersUI.localization.getLocalizedString("mapLayers:Messages.NotSupported"));
  const activeViewport = useActiveViewport();
  const ref = React.useRef<HTMLDivElement>(null);
  const isGeoLocated = useIsGeoLocated(activeViewport);

  if (isGeoLocated && activeViewport?.view.isSpatialView()) {
    return (
      <div ref={ref} className="map-manager-layer-host" data-testid="map-layers-widget">
        <MapLayerManager
          activeViewport={activeViewport}
          mapLayerOptions={props.mapLayerOptions}
        />
      </div>
    );
  }

  return (
    <Flex justifyContent="center" className="map-layers-widget-not-geo-located">
      <div className="map-manager-not-geo-located-text">{notGeoLocatedMsg}</div>
    </Flex>
  );
}
